<template>
     <main class="page-main">
        <Breadcrumbs>
            <template slot="li">
                <li>/<span> Sales Section</span></li>
            </template>
        </Breadcrumbs>

        <div class="block">
            <div class="container">
                <div class="title center">
                    <h1>Sales Section</h1>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <a @click="$router.push({name: 'SaleRegister'})" class="banner-wrap">
                    <div class="banner style-9 autosize-text image-hover-scale" data-fontratio="6.4" style="font-size: 100px;">
                        <img src="">
                        <div class="banner-caption vertb">
                            <div class="vert-wrapper">
                                <div class="vert">
                                    <div class="text-1 text-hoverslide" data-hcolor="#ffffff"><span>
                                        <span class="text">Register a new Sale</span><span class="hoverbg"></span></span>
                                    </div>
                                    <div class="text-2">Create new Customer</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "SalesArea"
}
</script>



// WEBPACK FOOTER //
// src/components/sales/List.vue